export default {
  GET_ORDER: 'GET_ORDER',
}
